<template>
  <div>
    <div class="priceContainer ">
      <v-btn :x-large="$vuetify.breakpoint.xl" :outlined="$vuetify.theme.dark" elevation="0"
        :disabled="!winPrice || disabled" v-if="placePrice && wpsOn && hasFeature('wpsButton')" large
        class="priceItem mr-2" :width="$vuetify.breakpoint.xl ? '120' : '90'" color="#F5F6F8"
        @click="clickPrice(runner, 0, 'COMBO', 'C', stake, winPrice, placePrice, showPrice)"><span
          class="title text-xl-h6">COMBO</span></v-btn>
      <v-btn :x-large="$vuetify.breakpoint.xl" :outlined="$vuetify.theme.dark" elevation="0"
        :disabled="!winPrice || disabled" large class="priceItem lightgreen--text mr-2"
        :width="$vuetify.breakpoint.xl ? '120' : '90'" color="#E7FFEA"
        @click="clickPrice(runner, winPrice, 'Win', 'W', stake)">W <span class="pl-1 title text-xl-h6">${{ winPrice || ' - '}}</span></v-btn>
      <v-btn :x-large="$vuetify.breakpoint.xl" :outlined="$vuetify.theme.dark" elevation="0"
        :disabled="!placePrice || disabled" v-if="placePrice && checkEnabled('P')" class="priceItem  blue--text mr-2"
        large :width="$vuetify.breakpoint.xl ? '120' : '90'" color="#DAF6FF"
        @click="clickPrice(runner, placePrice, 'Place', 'P', stake)">P <span class="pl-1 title text-xl-h6">${{ placePrice
          || ' -' }}</span></v-btn>
      <v-btn :x-large="$vuetify.breakpoint.xl" :outlined="$vuetify.theme.dark" elevation="0" disabled
        v-else-if="!showPrice && checkEnabled('P')" class="priceItem  blue--text mr-2" large
        :width="$vuetify.breakpoint.xl ? '120' : '90'" color="#DAF6FF">P <span class="pl-1 title text-xl-h6">${{ placePrice
          || ' -' }}</span></v-btn>
      <v-btn :x-large="$vuetify.breakpoint.xl" :outlined="$vuetify.theme.dark" elevation="0"
        :disabled="!showPrice || disabled" v-if="showPrice && checkEnabled('S')" large
        class="priceItem purple--text float-left" :width="$vuetify.breakpoint.xl ? '120' : '90'" color="#F2EEFF"
        @click="clickPrice(runner, showPrice, 'Show', 'S', stake)">S <span class="pl-1 title text-xl-h6">${{ showPrice || ' - '}}</span></v-btn>
      <v-btn :x-large="$vuetify.breakpoint.xl" :outlined="$vuetify.theme.dark" elevation="0" disabled
        v-else-if="!showPrice && checkEnabled('S')" class="priceItem  white--text float-left" large
        :width="$vuetify.breakpoint.xl ? '120' : '90'" color="blue-grey lighten-1">S <span
          class="pl-1 title text-xl-h6">${{ showPrice || ' -' }}</span></v-btn>
    </div>
    <BetSlipAddModal v-if="hasFeature('newNavigation') && showThisBetModal" @close="showThisBetModal = false"
      :rejectedTicket="rejectedTicket" :race="race" :clearStake="clearStake" :item="modalItem" :price="modalPrice"
      :bet="betType" :betCode="code" :confirmedStake="confirmedStake" :placePrice="placePrice" :showPrice="showPrice"
      :W="W" :P="P" :S="S"></BetSlipAddModal>
    <DialogModal :betError="betError" :clearSetStake="clearSetStake" :betStatus="betStatus" :betId="betId"
      :selectedRaceId="selectedRace.id" :clearModal="clearModal" :refundError="refundError" :alertStake="alertStake"
      :ticketId="ticketId" :refundModal="refundModal" :refundAmt="refundAmt" :sentBet="sentBet" :reloadRace="reloadRace"
      :addTransaction="addTransaction" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DialogModal from './DialogModal'
import BetSlipAddModal from './BetSlipAddModal'
import { WPSAVAILABLE, PRICE_DISPLAY } from '../common/constants'
import axios from 'axios'

export default {
  name: 'RunnerOdds',
  data() {
    return {
      stake: 0,
      showThisStakeModal: false,
      showThisBetModal: false,
      alertStake: false,
      sentBet: false,
      betStatus: null,
      betId: null,
      betError: null,
      refundAmt: null,
      ticketId: null,
      refundModal: false,
      refundError: false,
      rejectedTicketStr: '',
      modalItem: {},
      W: null,
      P: null,
      S: null
    }
  },
  props: {
    winPrice: Number,
    placePrice: Number,
    showPrice: Number,
    runner: Object,
    disabled: Boolean,
    race: Object
  },
  components: {
    BetSlipAddModal,
    DialogModal
  },
  computed: {
    ...mapGetters(['getTerminalId', 'hasFeature', 'getStoredPayment', 'getBetSlip', 'getSelectedRace', 'getVenueName']),
    selectedRace() {
      return this.getSelectedRace || {}
    },
    wpsOn() {
      const venue = this.getVenueName
      return (WPSAVAILABLE[venue])
    },
  },
  methods: {
    ...mapActions(['selectRace', 'loadRunners', 'clearStorePayment']),
    checkEnabled(v) {
      const showDisplay = PRICE_DISPLAY
      const enabled = showDisplay.find(c => c.venueName === this.getVenueName && c.display === v)?.enable
      return enabled
    },
    clickPrice(item, price, type, betCode, stake, w, p, s) {
      this.modalItem = item
      this.modalPrice = price
      this.betType = type
      this.code = betCode
      this.confirmedStake = stake
      this.showThisBetModal = true
      this.W = w
      this.P = p
      this.S = s
    },
    setStake(value) {
      this.stake = value
      this.showThisStakeModal = false
    },
    clearStake(enteredStake, betStatus, betId, error, refundAmt, ticketId) {
      this.stake = enteredStake
      this.betStatus = betStatus
      this.betId = betId
      this.betError = error
      this.refundAmt = refundAmt
      this.ticketId = ticketId
      this.showThisBetModal = false
    },
    clearModal() {
      this.refundModal = false,
        this.alertStake = false,
        this.refundError = false
    },
    async reloadRace() {
      this.sentBet = false
    },

    async clearSetStake() {
      this.sentBet = false
      this.stake = 'sent'
    },
    rejectedTicket(v) {
      this.rejectedTicketStr = v
    },
    refundThisTicket(v, amt) {
      if (!window.refundTicket) {
        window.refundTicket = console.log
      }
      window.refundTicket(JSON.stringify(v, amt))
    },
    //this is just never gonna be used as i know, as the dialog is based on alertStake = true, but I can't see anywhere we set the value to true...
    async addTransaction(transAmt, typeId) {

      await axios.post(`${process.env.VUE_APP_LEDGER_ENDPOINT}public/AddTransaction`, {
        terminalId: this.getTerminalId,
        betId: this.betId,
        amount: transAmt,
        type: typeId,
      })
        .then(() => {
          this.refundModal = true
          this.refundThisTicket(this.rejectedTicketStr, this.getStoredPayment)
          this.clearStorePayment()
        })
        .catch(() => {
          this.refundModal = true
          this.refundError = true
        })
    },

  }
}
</script>

<style scoped>.priceContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
}

.priceItem {
  align-self: flex-end;
}</style>
